import React from 'react';
import SectionHeading from './SectionHeading';

const Location = () => {
    return (
        <div id="location" className="bg-gray-50 py-16 md:py-20">
            <section data-aos="zoom-in-down" className="container-app">
                <SectionHeading eyebrow="Temukan Kami" title="Lokasi Kami" />

                <div className="flex flex-col items-center justify-center">
                    <p className="text-center text-slate-600 mb-2">
                        Kunjungi kantor kami di alamat berikut atau lihat peta di bawah ini:
                    </p>
                    <p className="text-center text-slate-900 font-semibold mb-8">
                        <strong>Alamat:</strong> Ruko De Green R7 / 7 Mangun Jaya, Tambun Selatan, Kab. Bekasi
                    </p>

                    <div className="w-full rounded-2xl overflow-hidden shadow-card border border-slate-100">
                        <div className="relative overflow-hidden" style={{ paddingBottom: "56.25%" }}>
                            <iframe
                                title="Google Maps Lokasi Kami"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.1307509246662!2d107.06072817453158!3d-6.246495361162469!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698f065d905d01%3A0x8a3a83f81f8b50e5!2sBerani%20Setia%20Waspada!5e0!3m2!1sid!2sid!4v1740315965925!5m2!1sid!2sid"
                                className="absolute top-0 left-0 w-full h-full border-0"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Location;
